<template>
  <div>
    <v-card>
    <v-data-table
      :headers="itemsTableFields"
      :items="items"
      tableClasses="item-table border"
      responsive
      disable-pagination
      hide-default-footer
      fixed-header
      max-height="200"
      item-key="title"
    >
     <template v-slot:[`item.deliveryDateUtc`]="{ item }">
             
   {{  jalaliDate(item.deliveryDateUtc )}}
     </template>
          <template v-slot:[`item.operations`]="{ item }">
             
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                @click="$emit('removeDeliveryItem', item)"
                >
                  <v-icon color="error" dark v-bind="attrs" v-on="on">
                    mdi-trash-can
                  </v-icon>
                </v-btn>
              </template>
              <span>حذف</span>
            </v-tooltip>
          </template>
             
    </v-data-table>
    </v-card>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import Helper from '@/core/helpers';

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  name: 'TradeRequestInventoryItemsList',
  props: ['items'],
  data() {
    return {
      itemsTableFields: [
        
        {
          value: 'deliveryDateUtc',
          text: 'تاریخ',
          sortable: true,
        },
        {
          value: 'amount',
          text: ' تعداد',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],

    };
  },
  watch:{
    selected(){
       this.$emit('selectedItem', this.selected)
    }
  }
};
</script>

<style></style>
